/** Names the ReadMe everywhere it appears: zip entry, worksheet, and first line. */
export const README_HEADING = "README";

const CAVEAT_HEADING = "Document Caveat";
const CAVEAT_BODY = "This document may only be used in line with the Terms of Use.";

const DISCLAIMER_HEADING = "Disclaimer";
const disclaimerIntro =
  "While every effort has been made to ensure that this document and the sources of information used herein are free of error, the authors:";
const disclaimerClauses = [
  "Are not liable for the accuracy, currency and reliability of any information provided in this publication",
  "Make no express or implied representation of warranty that any estimate of forecast will be achieved or that any statement as to the future matters contained in this publication will prove correct",
  "Expressly disclaim any and all liability arising from the information contained in this report including, without, errors in, or omissions contained in the information; Except so far as liability under any statute cannot be excluded",
  "Accept no responsibility arising in any way from errors in, or omissions contained in the information",
  "Do not represent that they apply any expertise on behalf of the reader or any other interested party",
  "Accept no liability for any loss or damage suffered by any person as a result of that person, of any other person, placing any reliance on the contents of this publication",
  "Assume no duty of disclosure or fiduciary duty to any interested party.",
];

const CONTACT = "Contact: www.XDI.systems";
const COPYRIGHT_NOTICE =
  "This document is protected by copyright. Public reproduction by any means is prohibited without prior written consent of XDI Pty Ltd.";
const IP_NOTICE =
  "XDI and Climate Risk Pty Ltd maintains the intellectual property rights for all of the tools used in this project.";

const getCopyright = () =>
  `© Copyright XDI Pty Ltd and Climate Risk Pty Ltd, ${new Date().getFullYear()}. All rights reserved. This document is subject to contract and contains confidential and proprietary information.`;

/** Rows which render as section headings, bolded in worksheet output. */
export const readmeHeadings = [CAVEAT_HEADING, DISCLAIMER_HEADING];

/** Single-column rows for the ReadMe worksheet. */
export const getReadmeRows = (title: string = README_HEADING): string[][] => [
  [title],
  [CAVEAT_HEADING],
  [CAVEAT_BODY],
  [""],
  [DISCLAIMER_HEADING],
  [`${disclaimerIntro} ${disclaimerClauses.join("; ")}`],
  [getCopyright()],
  [CONTACT],
  [""],
  [COPYRIGHT_NOTICE],
  [IP_NOTICE],
];

/** Plain-text rendering of the same content, for the README.txt zip entry. */
export const getReadmeText = (title: string = README_HEADING): string =>
  [
    title,
    "",
    CAVEAT_HEADING,
    "-".repeat(CAVEAT_HEADING.length),
    CAVEAT_BODY,
    "",
    DISCLAIMER_HEADING,
    "-".repeat(DISCLAIMER_HEADING.length),
    disclaimerIntro,
    ...disclaimerClauses.map((clause) => `- ${clause}`),
    "",
    getCopyright(),
    CONTACT,
    "",
    COPYRIGHT_NOTICE,
    IP_NOTICE,
  ].join("\n");
